import { render, staticRenderFns } from "./ListShipmentEstimationPage.vue?vue&type=template&id=388e5f50"
import script from "./ListShipmentEstimationPage.vue?vue&type=script&lang=js"
export * from "./ListShipmentEstimationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports